import { MechanicType } from './../../interfaces/mechanic/ocr-model';
import { AdminProduct } from './../../../list-purchase/share/interface/base';
import { MechanicService } from './../../services/mechanic/mechanic.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bankerselect',
  templateUrl: './bankerselect.component.html',
  styleUrls: ['./bankerselect.component.scss'],
})
export class BankerselectComponent implements OnInit {

  @Output()
  public selectEvent = new EventEmitter<string[]>();
  public products: AdminProduct[] = [];
  constructor(private mechanicService: MechanicService ) { }

  async ngOnInit() {
    this.products = await this.mechanicService.getProductAdminByMechanic(MechanicType.ExtraGift).toPromise();
  }

  public selectBanker(): void
  {
    var res: string[] = [];
    this.products.forEach(function(i){
      if(i.checked)
      {
        res.push(i.productId);
      }
    });
    this.selectEvent.emit(res);
  }

}
